<!-- <app-generic-loader [isLoader]="isLoading"></app-generic-loader> -->
<form [formGroup]="form" style="height: 100%;">
    <div class="SnapshotContainer">
        <div class="SnapshotLeftArea">
            <div class="SnapshotTopFieldArea">
                <div class="SnapshotFields" id="SnapshotFields" style="width: 11%;">
                    <div class="SnapshotFieldheading">SNAPSHOT NAME</div>
                    <div class="lineSeparation"></div>
                    <input type="text" #snapshotInput formControlName="snapshotName" minlength="5"
                        placeholder="Enter Snapshot Name" class="SnapshotFieldInput snapshotName"
                        id="SnapshotNameFieldInput{{id}}">
                </div>

                <!-- <div class="SnapshotFields" id="SnapshotFields" style="width: 12%;">
                    <div class="SnapshotFieldheading">SNAPSHOT TYPE</div>
                    <div class="lineSeparation"></div>
                    <select formControlName="snapshotType" class="SnapshotFieldInput" #snapshotTypeSelect
                        style="font-size: 0.65rem; font-weight: 600; font-family: 'KantarBrown-Regular';">
                        <option value="" disabled selected style="display: none;">Select</option>
                        <option *ngFor="let type of snapshotTypes" [value]="type.name">{{type.name}}</option>
                    </select>
                </div> -->

                <div (mouseleave)="showStudyNameDropdown = false" class="SnapshotFields" id="SnapshotFieldsStudyNames"  style="width: 12%;">
                    <div class="SnapshotFieldheading">STUDY NAMES</div>
                    <div class="lineSeparation"></div>
                    <div style="height: 40%;  margin-top:1vh;">
                        <button class="drop-toggle btn flat" (click)="showStudyNameDropdown=!showStudyNameDropdown"
                            style="display: flex; flex-direction: row; padding: 1% 3%;align-items: center;height: 100%;">
                            <span id="studyNamesArea" *ngIf="checkedList.length<=0"
                                style="font-weight: bold;font-size: 0.7rem;">Select</span>
                            <span id="studyNamesArea" *ngIf="checkedList.length>0" title="{{checkedList}}">{{checkedList.join(', ')}}</span>
                            <div class="downarrow" style="font-weight: bold;"></div>
                        </button>
                        <div class="drop-show" *ngIf="showStudyNameDropdown">
                            <!-- <label *ngFor="let a of studyNames" class="drop-study-name">
                                <input [type]="'radio'" [checked]="a.selected != null ?a.selected : false"
                                    class="studyNameRadio" (change)="getSelectedValueStudyName(a,a.name)" />
                                <span title="{{a.name}}">{{a.name}}</span>
                            </label> -->
                            <label *ngFor="let a of studyNames" class="drop-study-name">
                                <input
                                    type="radio"
                                    name="studyNameGroup"
                                    [value]="a.name"
                                    class="studyNameRadio"
                                    [checked]="!!a.selected"
                                    (change)="getSelectedValueStudyName(a, a.name)"
                                />
                                <span title="{{a.name}}">{{a.name}}</span>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- <div class="SnapshotFields" id="SnapshotFieldsNumber_of_Widgets">
                    <div class="SnapshotFieldheading">NUMBER OF WIDGETS</div>
                    <div class="lineSeparation"></div>
                    <select [(ngModel)]="numberOfWidget" class="SnapshotFieldInput" formControlName="widgetTypeForm"
                        #widgetTypeSelect (change)="numberOfWidgetsCLick($event)"
                        style="font-size: 0.65rem; font-weight: 600; font-family: 'KantarBrown-Regular';">
                        <option value="" disabled selected style="display: none;">Select</option>
                        <option *ngFor="let type of numberOfWidgets" [value]="type.name">{{type.name}}</option>
                    </select>
                </div> -->

                <!-- <div class="SnapshotFields" id="SnapshotFieldsSnapshot_Layout" style="margin-right: 0%;">
                    <div class="SnapshotFieldheadingGroup">
                        <div class="SnapshotFieldheading" style="width: 90%;">SNAPSHOT LAYOUT </div>
                        <div class="expand_Image" (click)="showWidgetLayout()">
                        </div>
                    </div>
                    <div class="lineSeparation"></div>
                    <div class="SnapshotFieldInput SnapshotFieldInputLayout" (click)="showWidgetLayout()"
                        aria-placeholder="Select layout from expand"></div>
                </div> -->
                <div class="SnapshotFields" id="SnapshotFieldsDocument_Repository" style="width: 27%;">
                    <div class="SnapshotFieldheading">DOCUMENT REPOSITORY</div>
                    <div class="lineSeparation" style="margin-top: 0.2%;"></div>
                    <div class="DocDP DF" style="margin-top: 0.4em;height: 40%;">
                          <div class="widget-body">
                        <div class="folder-file-container">
              <div class="folder-file-block">
                <div class="folder-file-items">
                  <label class="folder-file-label">{{otherConstants.DOCUMENT_ITEM1_LABEL1}}</label>
                  <div class="folder-file-dropdown folder-dd" (click)="onFolderDropdownClick()">
                    <div class="dropdown-text">{{selected_FolderName}}</div>
                    <div class="drop-down-icon" [ngClass]="{'drop-up-icon':showFolders}"></div>
                  </div>
                  <div class="folder-file-dropdown-container folder-dd" *ngIf="showFolders">
                    <div class="document-dropdown-items document-search-block">
                      <input type="text" placeholder="Search" [(ngModel)]="search_FolderName"
                        (input)="onFolderNameSearchChange()">
                    </div>
                    <div class="document-dropdown-items" *ngFor="let item of listOfFolders"
                      (click)="onFolderClick(item)">
                      <div class="dropdown-item-text">{{item}}</div>
                      <div class="dropdown-item-icon"></div>
                    </div>
                  </div>
                </div>
                <!-- <div class="folder-file-items">
                  <label class="widget-item-label">{{otherConstants.DOCUMENT_ITEM1_LABEL2}}</label>
                  <input class="widget-input folder-file-input"  type="text" [(ngModel)]="document_FolderName"  placeholder="Folder Name">
                </div>
                <div class="folder-file-items document-btn-container">
                  <div class="document-btns config-btn" title="{{buttonNameConstants.DOCUMENT_SAVE}}">
                    <div class="btn-icon clear-all-icon"></div>
                    <div class="btn-text">{{buttonNameConstants.DOCUMENT_SAVE}}</div>
                  </div>
                </div> -->
              </div>
              <div class="folder-file-block">
                <div class="folder-file-items">

                  <label class="folder-file-label">{{otherConstants.DOCUMENT_ITEM2_LABEL1}}</label>
                  <div class="folder-file-dropdown file-dd" (click)="onFileDropdownClick()">
                    <div class="dropdown-text">{{selected_FileName}}</div>
                    <div class="drop-down-icon" [ngClass]="{'drop-up-icon':showFiles}"></div>
                  </div>
                  <div class="folder-file-dropdown-container file-dd" *ngIf="showFiles">
                    <div class="document-dropdown-items document-search-block">
                      <input type="text" placeholder="Search" [(ngModel)]="search_FileName"
                        (input)="onFileNameSearchChange()">
                    </div>
                                        <div class="document-dropdown-items" *ngFor="let file of listOfFiles" (click)="onFileClick(file)" [attr.title]="file.fileName">
                                            <span class="dropdown-item-text">{{file.fileName}}</span>
                                        </div>
                    <div class="document-dropdown-items" *ngIf="listOfFiles.length==0">
                      No Data Available
                    </div>
                  </div>
                </div>
                <!-- <div class="folder-file-items">
                  <label class="widget-item-label">{{otherConstants.DOCUMENT_ITEM2_LABEL2}}</label>
                  <input class="widget-input folder-file-input" type="text" [(ngModel)]="document_FileName"
                    placeholder="No file selected.." readonly>
                </div> -->
                
              </div>
              
            </div>
            
            </div>
            <div class="folder-file-items document-btn-container">
                  <div class="document-btns config-btn" title="{{buttonNameConstants.DOCUMENT_UPLOAD}}"
                    *ngIf="selected_FolderName!=otherConstants.FOLDER_SELECTED_DEFAULT_VAL">
                    <label for="doc-file-upload" class="upload-label">
                      <i class="btn-icon clear-all-icon"></i> {{buttonNameConstants.DOCUMENT_UPLOAD}}
                    </label>
                    <input type="file" id="doc-file-upload" class="file-input" (change)="onDocFileChange($event)">
                  </div>
                  <!-- <div class="document-btns config-btn" title="{{buttonNameConstants.DOCUMENT_UPLOAD}}"
                  *ngIf="selected_FolderName!=otherConstants.FOLDER_SELECTED_DEFAULT_VAL">
                    <div class="btn-icon clear-all-icon"></div>
                    <div class="btn-text">{{buttonNameConstants.DOCUMENT_UPLOAD}}</div>
                  </div> -->
                  <div class="document-btns config-btn" title="{{buttonNameConstants.DOCUMENT_DELETE}}"
                    *ngIf="selected_FileName!=otherConstants.FILE_SELECTED_DEFAULT_VAL" (click)="onDeleteFileClick()">
                    <div class=" btn-icon-delete delete-icon"></div>
                    <div class="btn-text">{{buttonNameConstants.DOCUMENT_DELETE}}</div>
                  </div>
                </div>
                        <!-- <div class="docField" style="width:32%">
                            <div class="FFCaption DF" style="margin-right: 0.5vw;">File</div>
                            <select formControlName="docFileType" class="SnapshotFieldInputDoc" #docFolderTypeSelect
                                style="font-size: 0.65rem; font-weight: 600; font-family: 'KantarBrown-Regular';">
                                <option value="" disabled selected style="display: none;">File 1</option>
                                <option *ngFor="let type of docRepFileTypes" [value]="type.name">{{type.name}}
                                </option>
                            </select>
                        </div>
                        <div class="docField" style="width:36%">
                            <div class="FFCaption DF" style="margin-right: 0.5vw;">New File</div>
                            <input formControlName="newFileText" type="text" style="width: 60%;"
                                placeholder="New file name" #newFileText>
                        </div> -->
                  
                    <!-- <div class="DocDPBtn DF">
                        <div class="DocBtnDiv">
                        <div class="button-img save"></div>
                        <div class="SnapshotButton" (click)="save()">Save</div>
                    </div>
                    <div class="DocBtnDiv">
                        <div class="button-img upload"></div>
                        <div class="SnapshotButton" (click)="save()">Upload</div>
                    </div>
                    <div class="DocBtnDiv">
                        <div class="button-img delete"></div>
                        <div class="SnapshotButton" (click)="save()">Delete</div>
                    </div> -->
                    </div>
                </div>

                <div class="SnapshotFields" id="SnapshotFieldsSave_Selection" style="width: 22%;">
                    <div class="SnapshotFieldheading">SAVE SELECTION</div>
                    <div class="lineSeparation"></div>
                    <div class="save-selection-area">
                        <div *ngFor="let selection of saveSelection" style="margin-top: 1vh;">
                            <input (change)="saveSelectionChecked(selection,$event)" type="checkbox"
                                id="{{selection.value}}" class="alignCheckClick" [checked]="selection.selected">
                            <label for="{{selection.value}}">{{selection.name}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="snapshotMiddleFieldArea">
                <div class="snapshot-feature-area">
                    <div class="snapshot-features">
                        SNAPSHOT FEATURES
                    </div>
                    <div class="features-set1-area">
                        <div class="SnapshotFields" id="SnapshotFieldsOutput_Configuration"
                            style="width: 25%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">OUTPUT CONFIGURATION</div>
                            <div class="lineSeparation"></div>
                            <div class="SnapshotFieldInput" id="outputconfiguration">
                                <!-- <input type="radio" id="admin" [checked]="adminDefinedFlag" class="alignClick" name="option" value="admin">
                        <label for="admin">Admin Defined</label><br>
                        <input type="radio" id="user" [checked]="!adminDefinedFlag" class="alignClick" name="option" value="user">
                        <label for="user">User Defined</label> -->
                                <div *ngFor="let config of outputconfiguration">
                                    <div (click)="outputconfigchecked(config)">
                                        <input type="radio" id="{{config.value}}" class="alignCheckClick"
                                            [checked]="config.selected" value="{{config.value}}">
                                        <label for="{{config.value}}">{{config.name}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="SnapshotFields" id="SnapshotFieldsFilter_Function"
                            style="width: 38%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">FILTER FUNCTION</div>
                            <div class="lineSeparation"></div>
                            <div class="SnapshotFieldInputBase" style="display:flex;margin-top:0.5rem;align-items:center;">
                                <input type="checkbox" 
                                    id="customBaseCheckbox"
                                    [checked]="customBaseInput"
                                    (click)="$event.stopPropagation()"
                                    (change)="onCustomBaseChange($event)"
                                    [disabled]="!isRespondentLevelFormat"
                                    [attr.aria-disabled]="!isRespondentLevelFormat"
                                    [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null">
                                <label for="customBaseCheckbox" (click)="$event.stopPropagation()" [class.disabled-text]="!isRespondentLevelFormat"
                                    [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null">Custom Base</label>
                            </div>

                            <div class="SnapshotFieldInputBase" style="margin-top:0.2rem; display:flex; align-items:center; gap:0.5rem;"> 
                                <!-- Dropdown (shown when checkbox is checked) -->
                                <div  style="position: relative; width:18.2rem">
                                    <button class="drop-toggle btn flat custom-base" (click)="toggleCustomBaseDropdown()"
                                        style="display: flex; flex-direction: row; padding: 0.3rem 0.6rem; align-items: center; font-size: 0.7rem; font-weight: 600;"
                                        [disabled]="!isRespondentLevelFormat"
                                        [attr.aria-disabled]="!isRespondentLevelFormat"
                                        [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null"
                                        [class.disabled-text]="!isRespondentLevelFormat">
                                        <span *ngIf="selectedCustomBases.length === 0">Select Metrics</span>
                                        <span *ngIf="selectedCustomBases.length > 0" [attr.title]="selectedCustomBases.join(', ')">
                                            {{selectedCustomBases.length}} selected
                                        </span>
                                        <div class="downarrow" style="font-weight: bold; margin-left: 0.5rem;width: 1.2rem; right: 0rem; height: 1.2rem;"></div>
                                    </button>
                                    <div class="drop-show custom-base-dropdown" *ngIf="showCustomBaseDropdown" style="position: absolute; z-index: 1000; top: 100%; left: 0; min-width: 18.2rem; max-height: 11em">
                                    <!-- Search -->

                                    <div style="display: flex; align-items: center; border-bottom: 1px solid #e0e0e0;">
                                        <div class="search-box-container"  (click)="$event.stopPropagation()">
                                            <input type="text" 
                                                id="txtCustombaseSearch"
                                                class="search-input" 
                                                placeholder="Search metrics..." 
                                                [(ngModel)]="customBaseSearchText"
                                                [ngModelOptions]="{standalone: true}"
                                                (input)="onCustomBaseSearchChange()"
                                                [style.width]="selectedCustomBases.length > 0 ? '15.5rem' : '16.5rem'">
                                           <span *ngIf="!customBaseSearchText" class="search-icon" style="height: 1rem"><span  class="search-icon-image"></span></span >    
                                        </div>
                                        <div *ngIf="selectedCustomBases.length > 0" class="reset-icon" 
                                            (click)="clearAllCustomBaseSelections($event)"
                                            title="Clear all selections">
                                            <span class="custom-base-resetall"></span>
                                        </div>
                                    </div>
                                        <div class="options-container">
                                        <!-- Select All Option -->
                                        <label class="drop-study-name" *ngIf="filteredCustomBaseMetrics.length > 0" style="font-weight: bold; ">
                                            <input type="checkbox" 
                                                [checked]="areAllCustomBasesSelected()" 
                                                (change)="onSelectAllCustomBase($event)" 
                                                [disabled]="!isRespondentLevelFormat"
                                                [attr.aria-disabled]="!isRespondentLevelFormat"
                                                [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null" />
                                            <span>Select All</span>
                                        </label>
                                        <!-- Individual Metrics -->
                                        <label *ngFor="let metric of filteredCustomBaseMetrics" class="drop-study-name">
                                            <input type="checkbox" 
                                                [checked]="isCustomBaseSelected(metric)" 
                                                (change)="onCustomBaseSelect(metric, $event)" 
                                                [disabled]="!isRespondentLevelFormat"
                                                [attr.aria-disabled]="!isRespondentLevelFormat"
                                                [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : metric" />
                                            <span [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : metric" [class.disabled-text]="!isRespondentLevelFormat">{{metric}}</span>
                                        </label>
                                        <div *ngIf="filteredCustomBaseMetrics.length === 0" class="drop-study-name" style="color: #999;">
                                            No metrics available
                                        </div>
                                        </div>
                                    </div>
                                </div>
                           </div>

                            <div class="SnapshotFieldInputBase" style="display:flex;margin-top:0.5rem;">
                                <div class="FFCaption base">Answer Base</div>
                                <div id="FF base" style="display:flex;    margin-left: 2.3rem;" (click)="toggleAnswerBase()">
                                    <button [ngStyle]="answerBaseInput ? {'background-color':'#8029B6','color':'white'} : {'background-color':'transparent','color':'black'}"
                                            id="FFyesno" class="toggleButtons" [disabled]="!isRespondentLevelFormat"
                                        [attr.aria-disabled]="!isRespondentLevelFormat"
                                        [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null"
                                        [class.disabled-text]="!isRespondentLevelFormat">Yes</button>
                                        <button [ngStyle]="!answerBaseInput ? {'background-color':'#8029B6','color':'white'} : {'background-color':'transparent','color':'black'}"
                                            id="FFyesno" class="toggleButtons" [disabled]="!isRespondentLevelFormat"
                                            [attr.aria-disabled]="!isRespondentLevelFormat"
                                            [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null"
                                            [class.disabled-text]="!isRespondentLevelFormat">No</button>
                                </div>                                
                            </div>
                           
                        </div>
                        <div class="SnapshotFields" id="SnapshotFieldsStatic_Text"
                            style="width: 25%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">STATIC TEXT</div>
                            <div class="lineSeparation"></div>
                            <div class="SnapshotFieldInput">
                                <div id="ST">
                                    <div id="STyesno"
                                        [style]="showStaticTextAreaFlag?'background-Color:#8029B6;color:white':'background-Color:transparent;color:black'"
                                        class="toggleButtons" (click)="showStaticTextArea($event)">Yes</div>
                                    <div id="STyesno"
                                        [style]="!showStaticTextAreaFlag?'background-Color:#8029B6;color:white':'background-Color:transparent;color:black'"
                                        class="toggleButtons" (click)="hideStaticTextArea($event)">No</div>
                                </div>
                                <!-- <input type="text" *ngIf="showStaticTextAreaFlag" class="StaticTextArea"
                            placeholder="Static Text"> -->
                                <textarea *ngIf="showStaticTextAreaFlag" formControlName="staticText" maxlength="150"
                                    #staticText (input)="onStaticTextChanged($event)" class="StaticTextArea"
                                    placeholder="Static Text"></textarea>
                            </div>
                        </div>
                        <!-- <div class="SnapshotFields" id="SnapshotFieldsSticky_Default_selection" style="width: 25%;">
                            <div class="SnapshotFieldheading">STICKY/DEFAULT SELECTION</div>
                            <div class="lineSeparation"></div>
                            <div class="SnapshotFieldInput">
                                <div *ngFor="let config of stickyDefaultSelection">
                                    <div (click)="stickyDefaultchecked(config)">
                                        <input type="radio" id="{{config.value}}" class="alignCheckClick"
                                            [checked]="config.selected">
                                        <label for="{{config.value}}">{{config.name}}</label>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="SnapshotFields" id="SnapshotFieldsUser_Management" style="width: 25%;">
                            <div class="SnapshotFieldheading">USER MANAGEMENT</div>
                            <div class="lineSeparation"></div>
                            <div class="SnapshotFieldInput">
                                <div *ngFor="let config of userManagementSelection">
                                    <div (click)="userManagementchecked(config,$event)">
                                        <input type="checkbox" id="{{config.value}}" class="alignCheckClick"
                                            [checked]="config.selected">
                                        <label for="{{config.value}}">{{config.name}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="features-set2-area">
                        <div class="SnapshotFields" id="SnapshotFieldsComparison_Points"
                            style="width: 18%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">COMPARISON POINTS</div>
                            <div class="lineSeparation"></div>
                            <div class="comparison-field-area">
                                <div *ngFor="let comparison of comparisonPoints">
                                    <input (change)="comparisionChecked(comparison,$event)" type="checkbox"
                                        id="{{comparison.value}}" class="alignCheckClick"
                                        [checked]="comparison.selected"
                                        [disabled]="!isRespondentLevelFormat"
                                        [attr.aria-disabled]="!isRespondentLevelFormat"
                                        [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null">
                                    <label for="{{comparison.value}}" [class.disabled-text]="!isRespondentLevelFormat"
                                        [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null">{{comparison.name}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="SnapshotFields" id="SnapshotFieldsTypes_of_Significance"
                            style="width: 19%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">TYPES OF SIGNIFICANCE</div>
                            <div class="lineSeparation"></div>
                            <div class="comparison-field-area">
                                <div *ngFor="let comparison of significance">
                                    <input (change)="signiFicanceTypeChecked(comparison,$event)" type="checkbox"
                                        id="{{comparison.value}}" class="alignCheckClick"
                                        [checked]="comparison.selected"
                                        [disabled]="!isRespondentLevelFormat"
                                        [attr.aria-disabled]="!isRespondentLevelFormat"
                                        [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null">
                                    <label for="{{comparison.value}}" [class.disabled-text]="!isRespondentLevelFormat"
                                        [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null">{{comparison.name}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="SnapshotFields" id="SnapshotFieldsMultiple_Confidence_Levels"
                            style="width: 24%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">MULTIPLE CONFIDENCE LEVELS</div>
                            <div class="lineSeparation"></div>
                            <div class="comparison-field-area">
                                <div *ngFor="let comparison of multipleConfidence">
                                    <input (change)="multipleConfidenceChecked(comparison,$event)" type="checkbox"
                                        id="{{comparison.value}}" class="alignCheckClick"
                                        [checked]="comparison.selected"
                                        [disabled]="!isRespondentLevelFormat"
                                        [attr.aria-disabled]="!isRespondentLevelFormat"
                                        [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null">
                                    <label for="{{comparison.value}}" [class.disabled-text]="!isRespondentLevelFormat"
                                        [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null">{{comparison.name}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="SnapshotFields" id="SnapshotFieldsCustom_Content"
                            style="width: 17%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">CUSTOM CONTENT</div>
                            <div class="lineSeparation"></div>
                            <div class="comparison-field-area">
                                <div *ngFor="let Content of customContentSelection">
                                    <input (change)="customContentChecked(Content,$event)" type="checkbox"
                                        id="{{Content.value}}" class="alignCheckClick"
                                        [checked]="Content.selected">
                                    <label for="{{Content.value}}">{{Content.name}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="SnapshotFields" id="SnapshotFieldsExport" style="width: 18%;">
                            <div class="SnapshotFieldheading">EXPORT</div>
                            <div class="lineSeparation"></div>
                            <div class="comparison-field-area">
                                <div *ngFor="let comparison of export">
                                    <input (change)="exportChecked(comparison,$event)" type="checkbox"
                                        id="{{comparison.value}}" class="alignCheckClick"
                                        [checked]="comparison.selected">
                                    <label for="{{comparison.value}}">{{comparison.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="features-set3-area">
                        <div class="SnapshotFields DF">
                            <div class="additionalCBDiv DF" *ngFor="let addCB of additionalCheckBoxSelection;let i = index;let isLast = last"
                            [ngStyle]="isLast ? {'width': '25%'} : {}" [ngClass]="{'disabled': (moduleConfigPropertiesDisplay[0] && additionalCheckBoxSelection[i].value !== undefined &&
                            moduleConfigPropertiesDisplay[0][additionalCheckBoxSelection[i].value] === 'NA')}">
                                    <input (change)="additionalCheckBoxchecked(addCB,$event)" type="checkbox"
                                    id="{{addCB.value}}" class="alignCheckClick" style="top: 0;"
                                    [checked]="addCB.selected"
                                    [disabled]="addCB.value === 'Entry_points_Multi_Select' ? !isRespondentLevelFormat : null"
                                    [attr.aria-disabled]="(addCB.value === 'Entry_points_Multi_Select') ? !isRespondentLevelFormat : null"
                                    [attr.title]="(addCB.value === 'Entry_points_Multi_Select' && !isRespondentLevelFormat) ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null">
                                <label for="{{addCB.value}}" [class.disabled-text]="addCB.value === 'Entry_points_Multi_Select' && !isRespondentLevelFormat"
                                    [attr.title]="addCB.value === 'Entry_points_Multi_Select' && !isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null">{{addCB.name}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="snapshotTypeArea">
            <div class="snapshot-features">
                SELECTION PANEL
            </div>
            <div class="selectionPanelArea">
                <div class="SnapshotFields" id="SnapshotFieldsSelection_Panel_Headers">
                    <div class="SnapshotFieldheading">SNAPSHOT TYPE</div>
                    <div class="lineSeparation"></div>
                    <div class="snapshot-type-area">
                        <div class="snapshot-type-checkbox">
                            <div class="singleBrandType">
                                <input type="checkbox" id="singleBrand" class="alignCheckClick"
                                    (click)="SnapshotTypeClick($event, 'singleBrand')">
                                <label class="snapshotTypeName" for="singleBrand">Single Brand</label>
                                <div class="expand-icon"  id="singleBrandType" (click)="StudytypeExpandClicks($event)">
                                </div>
                            </div>
                            <div class="lineSeparation" *ngIf="!showSingleBrand"></div>
                            <div class="sub-div" *ngIf="showSingleBrand" style=" margin-left: 1%;">
                                <!-- Entry Points -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading" style="display: flex; align-items: center; gap: 10px; cursor: pointer;"
                                         [style.cursor]="!hasValidEntryPoints(entryPointsSB) ? 'not-allowed' : 'pointer'"
                                         (click)="hasValidEntryPoints(entryPointsSB) && toggleEntryPointsSB()">
                                        <span>ENTRY POINTS</span>
                                        <div class="expand-icon-audience"
                                             [class.selected]="showEntryPointsSB"
                                             [class.disabled]="!hasValidEntryPoints(entryPointsSB)"
                                             style="margin-left: auto;">
                                        </div>
                                    </div>
                                    <div class="lineSeparation"></div>
                                    <div class="entry-points-field-area" *ngIf="showEntryPointsSB">
                                        <div *ngFor="let entryPoint of entryPointsSB" class="checkboxClass">
                                            <input *ngIf="entryPoint.variable_code !=''"
                                                (change)="ExportEntryPointsClicks(entryPoint, entryPointsSB,$event)"
                                                type="checkbox" id="{{entryPoint.variable_label}}"
                                                class="alignCheckClick" [checked]="entryPoint.is_selected">
                                            <label *ngIf="entryPoint.variable_code !=''"
                                                for="{{entryPoint.variable_label}}">{{
                                                entryPoint.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <!-- Dimensions -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading" style="display: flex; align-items: center; gap: 10px; cursor: pointer;"
                                         [style.cursor]="!hasValidDimensions(dimensionsSB) ? 'not-allowed' : 'pointer'"
                                         (click)="hasValidDimensions(dimensionsSB) && toggleDimensionsSB()">
                                        <span>DIMENSIONS</span>
                                        <div class="expand-icon-audience"
                                             [class.selected]="showDimensionsSB"
                                             [class.disabled]="!hasValidDimensions(dimensionsSB)"
                                             style="margin-left: auto;">
                                        </div>
                                    </div>
                                    <div class="lineSeparation"></div>
                                    <div class="dimensions-field-area" *ngIf="showDimensionsSB">
                                        <!-- Dimension checkboxes go here -->
                                        <div *ngFor="let dimension of dimensionsSB">
                                            <input (change)="ExportDimensionsClicks(dimension, dimensionsSB,$event)"
                                                *ngIf="dimension.variable_code !=''" type="checkbox"
                                                id="{{dimension.variable_label}}" class="alignCheckClick"
                                                [checked]="dimension.is_selected">
                                            <label *ngIf="dimension.variable_code !=''"
                                                for="{{dimension.variable_label}}">{{dimension.variable_code==""?"None":dimension.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-div-note-area">
                                    <div class="note-image"></div>
                                    <div class="sub-div-note"><span style="color: black; font-weight: bold;">Note:
                                        </span>Please do not add Time Period and Brand as Entry Point or
                                        Dimensions</div>
                                </div>
                                <div class="lineSeparation"></div>
                            </div>
                        </div>

                        <div class="snapshot-type-checkbox">
                            <div class="multiBrandType">
                                <input type="checkbox" id="multiBrand" class="alignCheckClick"
                                    (click)="SnapshotTypeClick($event, 'multiBrand')">
                                <label class="snapshotTypeName" for="multiBrand">Multiple Brands</label>
                                <div class="expand-icon"  id="multiBrandType" (click)="StudytypeExpandClicks($event)">
                                </div>
                            </div>
                            <div class="lineSeparation" *ngIf="!showMultiBrand"></div>
                            <div class="sub-div" *ngIf="showMultiBrand" style=" margin-left: 1%;">
                                <!-- Entry Points -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading" style="display: flex; align-items: center; gap: 10px; cursor: pointer;"
                                         [style.cursor]="!hasValidEntryPoints(entryPointsMB) ? 'not-allowed' : 'pointer'"
                                         (click)="hasValidEntryPoints(entryPointsMB) && toggleEntryPointsMB()">
                                        <span>ENTRY POINTS</span>
                                        <div class="expand-icon-audience"
                                             [class.selected]="showEntryPointsMB"
                                             [class.disabled]="!hasValidEntryPoints(entryPointsMB)"
                                             style="margin-left: auto;">
                                        </div>
                                    </div>
                                    <div class="lineSeparation"></div>
                                    <div class="entry-points-field-area" *ngIf="showEntryPointsMB">
                                        <div *ngFor="let entryPoint of entryPointsMB" class="checkboxClass">
                                            <input (change)="ExportEntryPointsClicks(entryPoint, entryPointsMB,$event)"
                                                *ngIf="entryPoint.variable_code !=''" type="checkbox"
                                                id="{{entryPoint.variable_label}}" class="alignCheckClick"
                                                [checked]="entryPoint.is_selected">
                                            <label *ngIf="entryPoint.variable_code !=''"
                                                for="{{entryPoint.variable_label}}">{{
                                                entryPoint.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <!-- Dimensions -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading" style="display: flex; align-items: center; gap: 10px; cursor: pointer;"
                                         [style.cursor]="!hasValidDimensions(dimensionsMB) ? 'not-allowed' : 'pointer'"
                                         (click)="hasValidDimensions(dimensionsMB) && toggleDimensionsMB()">
                                        <span>DIMENSIONS</span>
                                        <div class="expand-icon-audience"
                                             [class.selected]="showDimensionsMB"
                                             [class.disabled]="!hasValidDimensions(dimensionsMB)"
                                             style="margin-left: auto;">
                                        </div>
                                    </div>
                                    <div class="lineSeparation"></div>
                                    <div class="dimensions-field-area" *ngIf="showDimensionsMB">
                                        <!-- Dimension checkboxes go here -->
                                        <div *ngFor="let dimension of dimensionsMB">
                                            <input (change)="ExportDimensionsClicks(dimension, dimensionsMB,$event)"
                                                *ngIf="dimension.variable_code !=''" type="checkbox"
                                                id="{{dimension.variable_label}}" class="alignCheckClick"
                                                [checked]="dimension.is_selected">
                                            <label *ngIf="dimension.variable_code !=''"
                                                for="{{dimension.variable_label}}">{{dimension.variable_code==""?"None":dimension.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-div-note-area">
                                    <div class="note-image"></div>
                                    <div class="sub-div-note"><span style="color: black; font-weight: bold;">Note:
                                        </span>Please do not add Time Period and Brand as Entry Point or
                                        Dimensions</div>
                                </div>
                                <div class="lineSeparation"></div>
                            </div>
                        </div>

                        <div class="snapshot-type-checkbox">
                            <div class="multiCategoryType">
                                <input type="checkbox" id="multiCategory" class="alignCheckClick"
                                    (click)="SnapshotTypeClick($event, 'multiCategory')">
                                <label class="snapshotTypeName" for="multiCategory">Multiple Categories</label>
                                <div class="expand-icon" id="multiCategoryType" (click)="StudytypeExpandClicks($event)">
                                </div>
                            </div>
                            <div class="lineSeparation" *ngIf="!showMultiCategory"></div>
                            <div class="sub-div" *ngIf="showMultiCategory" style=" margin-left: 1%;">
                                <!-- Entry Points -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading" style="display: flex; align-items: center; gap: 10px; cursor: pointer;"
                                         [style.cursor]="!hasValidEntryPoints(entryPointsMC) ? 'not-allowed' : 'pointer'"
                                         (click)="hasValidEntryPoints(entryPointsMC) && toggleEntryPointsMC()">
                                        <span>ENTRY POINTS</span>
                                        <div class="expand-icon-audience"
                                             [class.selected]="showEntryPointsMC"
                                             [class.disabled]="!hasValidEntryPoints(entryPointsMC)"
                                             style="margin-left: auto;">
                                        </div>
                                    </div>
                                    <div class="lineSeparation"></div>
                                    <div class="entry-points-field-area" *ngIf="showEntryPointsMC">
                                        <div *ngFor="let entryPoint of entryPointsMC" class="checkboxClass">
                                            <input (change)="ExportEntryPointsClicks(entryPoint, entryPointsMC,$event)"
                                                *ngIf="entryPoint.variable_code !=''" type="checkbox"
                                                id="{{entryPoint.variable_label}}" class="alignCheckClick"
                                                [checked]="entryPoint.is_selected">
                                            <label *ngIf="entryPoint.variable_code !=''"
                                                for="{{entryPoint.variable_label}}">{{
                                                entryPoint.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <!-- Dimensions -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading" style="display: flex; align-items: center; gap: 10px; cursor: pointer;"
                                         [style.cursor]="!hasValidDimensions(dimensionsMC) ? 'not-allowed' : 'pointer'"
                                         (click)="hasValidDimensions(dimensionsMC) && toggleDimensionsMC()">
                                        <span>DIMENSIONS</span>
                                        <div class="expand-icon-audience"
                                             [class.selected]="showDimensionsMC"
                                             [class.disabled]="!hasValidDimensions(dimensionsMC)"
                                             style="margin-left: auto;">
                                        </div>
                                    </div>
                                    <div class="lineSeparation"></div>
                                    <div class="dimensions-field-area" *ngIf="showDimensionsMC">
                                        <!-- Dimension checkboxes go here -->
                                        <div *ngFor="let dimension of dimensionsMC">
                                            <input (change)="ExportDimensionsClicks(dimension, dimensionsMC,$event)"
                                                *ngIf="dimension.variable_code !=''" type="checkbox"
                                                id="{{dimension.variable_label}}" class="alignCheckClick"
                                                [checked]="dimension.is_selected">
                                            <label *ngIf="dimension.variable_code !=''"
                                                for="{{dimension.variable_label}}">{{dimension.variable_code==""?"None":dimension.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-div-note-area">
                                    <div class="note-image"></div>
                                    <div class="sub-div-note"><span style="color: black; font-weight: bold;">Note:
                                        </span> Please do not add Time Period, Categories and Brand as Entry Point or
                                        Dimensions</div>
                                </div>
                                <div class="lineSeparation"></div>
                            </div>
                        </div>

                        <div class="snapshot-type-checkbox">
                            <div class="multiMarketType">
                                <input type="checkbox" id="multiMarket" class="alignCheckClick"
                                    (click)="SnapshotTypeClick($event, 'multiMarket')">
                                <label class="snapshotTypeName" for="multiMarket">Multiple Markets</label>
                                <div class="expand-icon" id="multiMarketType" (click)="StudytypeExpandClicks($event)">
                                </div>
                            </div>
                            <div class="lineSeparation" *ngIf="!showMultiMarket"></div>
                            <div class="sub-div" *ngIf="showMultiMarket" style=" margin-left: 1%;">
                                <!-- Entry Points -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading" style="display: flex; align-items: center; gap: 10px; cursor: pointer;"
                                         [style.cursor]="!hasValidEntryPoints(entryPointsMM) ? 'not-allowed' : 'pointer'"
                                         (click)="hasValidEntryPoints(entryPointsMM) && toggleEntryPointsMM()">
                                        <span>ENTRY POINTS</span>
                                        <div class="expand-icon-audience"
                                             [class.selected]="showEntryPointsMM"
                                             [class.disabled]="!hasValidEntryPoints(entryPointsMM)"
                                             style="margin-left: auto;">
                                        </div>
                                    </div>
                                    <div class="lineSeparation"></div>
                                    <div class="entry-points-field-area" *ngIf="showEntryPointsMM">
                                        <div *ngFor="let entryPoint of entryPointsMM" class="checkboxClass">
                                            <input (change)="ExportEntryPointsClicks(entryPoint, entryPointsMM,$event)"
                                                *ngIf="entryPoint.variable_code !=''" type="checkbox"
                                                id="{{entryPoint.variable_label}}" class="alignCheckClick"
                                                [checked]="entryPoint.is_selected">
                                            <label *ngIf="entryPoint.variable_code !=''"
                                                for="{{entryPoint.variable_label}}">{{
                                                entryPoint.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <!-- Dimensions -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading" style="display: flex; align-items: center; gap: 10px; cursor: pointer;"
                                         [style.cursor]="!hasValidDimensions(dimensionsMM) ? 'not-allowed' : 'pointer'"
                                         (click)="hasValidDimensions(dimensionsMM) && toggleDimensionsMM()">
                                        <span>DIMENSIONS</span>
                                        <div class="expand-icon-audience"
                                             [class.selected]="showDimensionsMM"
                                             [class.disabled]="!hasValidDimensions(dimensionsMM)"
                                             style="margin-left: auto;">
                                        </div>
                                    </div>
                                    <div class="lineSeparation"></div>
                                    <div class="dimensions-field-area" *ngIf="showDimensionsMM">
                                        <!-- Dimension checkboxes go here -->
                                        <div *ngFor="let dimension of dimensionsMM">
                                            <input (change)="ExportDimensionsClicks(dimension, dimensionsMM,$event)"
                                                *ngIf="dimension.variable_code !=''" type="checkbox"
                                                id="{{dimension.variable_label}}" class="alignCheckClick"
                                                [checked]="dimension.is_selected">
                                            <label *ngIf="dimension.variable_code !=''"
                                                for="{{dimension.variable_label}}">{{dimension.variable_code==""?"None":dimension.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-div-note-area">
                                    <div class="note-image"></div>
                                    <div class="sub-div-note"><span style="color: black; font-weight: bold;">Note:
                                        </span> Please do not add Time Period, Brands and Market as Entry Point or
                                        Dimensions.<br></div>
                                </div>
                                <div class="lineSeparation"></div>
                            </div>
                        </div>
                        <div class="snapshot-type-checkbox" >
                         <div class="audienceSnapshotType">
                                <input type="checkbox" id="audienceSnapshot" class="alignCheckClick"
                                    (click)="SnapshotTypeClick($event, 'audienceSnapshot')">
                                <label class="snapshotTypeName" for="audienceSnapshot">Audience Snapshot</label>
                                <div class="expand-icon"  id="audienceSnapshotType" (click)="StudytypeExpandClicks($event)">
                                </div>
                            </div>
                            <div class="lineSeparation" *ngIf="!showAudienceSnapshot"></div>
                            <div class="sub-div" *ngIf="showAudienceSnapshot" style=" margin-left: 1%;">
                                <div class="SnapshotFields" id="SnapshotFieldsCohort" style="margin-bottom: 1%;">
                                    <!-- <div class="SnapshotFieldheading">AUDIENCE</div> -->
                                    <div class="lineSeparation"></div>
                                    <div class="cohort-selection-area" style="display: flex; gap: 20px; padding: 10px 0;">
                                        <div style="display: flex; align-items: center;">
                                            <input type="radio" id="singleCohort" name="cohortType" value="single" 
                                                class="alignClick" [checked]="audienceCohortType === 'single'"
                                                (change)="onCohortTypeChange('single')">
                                            <label for="singleCohort" style="margin-left: 5px; font-size: 0.7rem; font-weight: 600;">Single Cohort</label>
                                        </div>
                                        <div style="display: flex; align-items: center;">
                                            <input type="radio" id="multipleCohort" name="cohortType" value="multiple" 
                                                class="alignClick" [checked]="audienceCohortType === 'multiple'"
                                                (change)="onCohortTypeChange('multiple')">
                                            <label for="multipleCohort" style="margin-left: 5px; font-size: 0.7rem; font-weight: 600;">Multiple Cohort</label>
                                        </div>
                                    </div>
                                </div>       
                                <!-- Entry Points -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading" style="display: flex; align-items: center; gap: 10px; cursor: pointer;"
                                         [style.cursor]="!hasValidEntryPoints(entryPointsAS) ? 'not-allowed' : 'pointer'"
                                         (click)="hasValidEntryPoints(entryPointsAS) && toggleEntryPointsAS()">
                                        <span>ENTRY POINTS</span>
                                        <div class="expand-icon-audience"
                                             [class.selected]="showEntryPointsAS"
                                             [class.disabled]="!hasValidEntryPoints(entryPointsAS)"
                                             style="margin-left: auto;">
                                        </div>
                                    </div>
                                    <div class="lineSeparation"></div>
                                    <div class="entry-points-field-area" *ngIf="showEntryPointsAS">
                                        <div *ngFor="let entryPoint of entryPointsAS" class="checkboxClass">
                                            <input *ngIf="entryPoint.variable_code !=''"
                                                (change)="ExportEntryPointsClicks(entryPoint, entryPointsAS,$event)"
                                                type="checkbox" id="{{entryPoint.variable_label}}"
                                                class="alignCheckClick" [checked]="entryPoint.is_selected">
                                            <label *ngIf="entryPoint.variable_code !=''"
                                                for="{{entryPoint.variable_label}}">{{
                                                entryPoint.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <!-- Dimensions -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading" style="display: flex; align-items: center; gap: 10px; cursor: pointer;"
                                         [style.cursor]="!hasValidDimensions(dimensionsAS) ? 'not-allowed' : 'pointer'"
                                         (click)="hasValidDimensions(dimensionsAS) && toggleDimensionsAS()">
                                        <span>DIMENSIONS</span>
                                        <div class="expand-icon-audience"
                                             [class.selected]="showDimensionsAS"
                                             [class.disabled]="!hasValidDimensions(dimensionsAS)"
                                             style="margin-left: auto;">
                                        </div>
                                    </div>
                                    <div class="lineSeparation"></div>
                                    <div class="dimensions-field-area" *ngIf="showDimensionsAS">
                                        <!-- Dimension checkboxes go here -->
                                        <div *ngFor="let dimension of dimensionsAS">
                                            <input (change)="ExportDimensionsClicks(dimension, dimensionsAS,$event)"
                                                *ngIf="dimension.variable_code !=''" type="checkbox"
                                                id="{{dimension.variable_label}}" class="alignCheckClick"
                                                [checked]="dimension.is_selected">
                                            <label *ngIf="dimension.variable_code !=''"
                                                for="{{dimension.variable_label}}">{{dimension.variable_code==""?"None":dimension.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                        
                                                                           
                                <!-- Audience Comparison -->
                                <div class="SnapshotFields audience-comparison-dropdown" id="SnapshotFieldsAudienceComparison" 
                                     >
                                     <!-- ; onSelectAllAudienceComparison($event) for checkbox to select all -->
                                    <div class="SnapshotFieldheading" style="display: flex; align-items: center; gap: 10px; cursor: pointer;"
                                         (click)="toggleAudienceComparisonDropdown()">
                                                                        <input type="checkbox" id="audienceComparison" class="alignCheckClick" 
                                                                            [checked]="(isAudienceComparisonChecked())"
                                                                            (change)="onAudienceComparisonChange($event)"
                                                                            (click)="$event.stopPropagation()"
                                                                            [attr.title]="!isRespondentLevelFormat ? 'This feature is not available for Aggregated/Semi-aggregated studies.' : null">
                                        <span>AUDIENCE COMPARISON</span>
                                        <div class="expand-icon-audience"
                                [class.selected]="showAudienceComparisonDropdown"
                                style="margin-left: auto;">
                            </div>
                                    </div>
                                    <div class="lineSeparation"></div>
                                    
                                 
                                    
                                    <!-- Dropdown Content -->
                                    <div class="audience-comparison-content" *ngIf="showAudienceComparisonDropdown && audienceComparisonEnabled">
                                        <!-- Search Box and Reset Button Container -->
                                        <div class="search-reset-container" style="padding: 3px; border-bottom: 1px solid #e0e0e0; display: flex; gap: 8px; align-items: center;">
                                            <!-- Search Box -->
                                            <div style="position: relative; display: flex; align-items: center; flex: 1;">
                                                <div class="search-icon-small" style="position: absolute; left: 8px;"></div>
                                                <input type="text" 
                                                       placeholder="Search" 
                                                       [(ngModel)]="audienceComparisonSearch"
                                                       (input)="onAudienceComparisonSearchChange()"
                                                       [ngModelOptions]="{standalone: true}"
                                                       style="width: 100%; padding: 6px 30px 6px 36px; border: none; font-size: 0.75rem; outline: none;">
                                              
                                            </div>
                                            
                                            <!-- Reset Button -->
                                            <button *ngIf="selectedAudienceComparisons && selectedAudienceComparisons.length > 0"
                                                    (click)="resetAudienceComparisonSelection();$event.stopPropagation()" 
                                                    class="reset-selection-btn"
                                                    title="Clear all selections"
                                                    style="padding: 6px 12px; background: white; border: 1px solid #D1D5DB; border-radius: 4px; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #374151; display: flex; align-items: center; justify-content: center; gap: 4px; transition: all 0.2s; white-space: nowrap;">
                                                <div class="reset-icon-small"></div>
                                                
                                            </button>
                                        </div>
                                        
                                        <!-- Options List -->
                                        <div class="audience-comparison-list" style="max-height: 200px; overflow-y: auto;">
                                            <!-- Select All Option -->
                                            
                                            <div class="audience-comparison-item select-all-item" 
                                                *ngIf="filteredAudienceComparision.length > 0">
                                                <input type="checkbox" 
                                                    id="selectAllAudience"
                                                    [checked]="areAllAudienceComparisonsSelected()"
                                                    (change)="onSelectAllAudienceComparison($event)"
                                                    class="alignCheckClick"
                                                    style="margin-right: 8px;">
                                                <label for="selectAllAudience" 
                                                    class="audience_config_name select-all-label">
                                                Select All
                                                </label>
                                            </div>
                                        
                                            <!-- Individual Items -->
                                            <div *ngFor="let item of filteredAudienceComparision" 
                                                 class="audience-comparison-item"
                                                 [class.selected]="isAudienceComparisonSelected(item)">
                                                <input type="checkbox" 
                                                       [id]="'audience_' + item.variable_code"
                                                       [checked]="isAudienceComparisonSelected(item)"
                                                       (change)="onAudienceComparisonSelect(item, $event)"
                                                       class="alignCheckClick"
                                                       style="margin-right: 8px;">
                                              
                                                <label *ngIf="item.config_name" 
                                                       [for]="'audience_' + item.variable_code"
                                                       class="audience_config_name"
                                                       [attr.title]="item.config_name">
                                                    {{ item.config_name }}
                                                </label>
                                                
                                            </div>
                                            
                                            <!-- No Results -->
                                            <div *ngIf="filteredAudienceComparision.length === 0" 
                                                 style="padding: 16px; text-align: center; color: #9CA3AF; font-size: 0.75rem;">
                                                No matching options found
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Total Sample -->
                                <div class="SnapshotFields audience-comparison-dropdown total-sample-dropdown" id="SnapshotFieldsTotalSample">
                                    <div class="SnapshotFieldheading" style="display: flex; align-items: center; gap: 10px; cursor: pointer;"
                                         (click)="toggleTotalSampleDropdown()">
                                        <input type="checkbox" id="totalSample" class="alignCheckClick" 
                                            [checked]="!!selectedTotalSample"
                                            (change)="onTotalSampleChange($event)"
                                            (click)="$event.stopPropagation()">
                                        <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; min-width: 0;">TOTAL SAMPLE</span>
                               <div class="expand-icon-audience"
           [class.selected]="showTotalSampleDropdown">
       </div>
                                    </div>
                                    <div class="lineSeparation"></div>
                                    
                                    <!-- Dropdown Content -->
                                    <div class="total-sample-content" *ngIf="showTotalSampleDropdown ">
                                        <!-- Search Box and Reset Button Container -->
                                        <div class="search-reset-container" style="padding: 8px; border-bottom: 1px solid #e0e0e0; display: flex; gap: 8px; align-items: center;">
                                            <!-- Search Box -->
                                            <div style="position: relative; display: flex; align-items: center; flex: 1;">
                                                <div class="search-icon-small" style="position: absolute; left: 8px;"></div>
                                                <input type="text" 
                                                       placeholder="Search" 
                                                       [(ngModel)]="totalSampleSearch"
                                                       (input)="onTotalSampleSearchChange()"
                                                       [ngModelOptions]="{standalone: true}"
                                                       style="width: 100%; padding: 6px 30px 6px 36px; border: none; font-size: 0.75rem; outline: none;">
                                                <!-- <div *ngIf="totalSampleSearch"
                                                     (click)="clearTotalSampleSearch()"
                                                     class="clear-search-icon"
                                                     style="position: absolute; right: 8px; cursor: pointer;">
                                                </div> -->
                                            </div>
                                            
                                             <!-- Reset Button -->
                                             <!-- <button *ngIf="selectedTotalSample"
                                                    (click)="resetTotalSampleSelection();$event.stopPropagation()" 
                                                    class="reset-selection-btn"
                                                    title="Clear selection"
                                                    style="padding: 6px 12px; background: white; border: none; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #374151; display: flex; align-items: center; justify-content: center; gap: 4px; transition: all 0.2s; white-space: nowrap;">
                                                <div class="reset-icon-small"></div>
                                                
                                            </button>  -->
                                        </div>
                                        
                                        <!-- Options List -->
                                        <div class="total-sample-list" style="max-height: 200px; overflow-y: auto;">
                                            <!-- Individual Items with Radio Buttons -->
                                            <div *ngFor="let item of filteredTotalSample" 
                                                 class="total-sample-item"
                                                 [class.selected]="isTotalSampleSelected(item)">
                                                <input type="radio" 
                                                       [id]="'totalsample_' + item.variable_code"
                                                       name="totalSampleRadio"
                                                       [checked]="isTotalSampleSelected(item)"
                                                       (change)="onTotalSampleSelect(item, $event)"
                                                       class="alignCheckClick"
                                                       style="margin-right: 8px;    margin-top: 0.1rem;">
                                              
                                                <label *ngIf="item.config_name" 
                                                       [for]="'totalsample_' + item.variable_code"
                                                       class="audience_config_name"
                                                       [attr.title]="item.config_name">
                                                    {{ item.config_name }}
                                                </label>
                                                
                                            </div>
                                            
                                            <!-- No Results -->
                                            <div *ngIf="filteredTotalSample.length === 0" 
                                                 style="padding: 16px; text-align: center; color: #9CA3AF; font-size: 0.75rem;">
                                                No matching options found
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                  <div class="sub-div-note-area">
                                    <div class="note-image"></div>
                                    <div class="sub-div-note"><span style="color: black; font-weight: bold;">Note:
                                        </span> Please do not add Time Period, Brands and Market as Entry Point or
                                        Dimensions.<br></div>
                                </div>
                                <!-- <div class="sub-div-note-area">
                                    <div class="note-image"></div>
                                   <div class="sub-div-note"><span style="color: black; font-weight: bold;">Note:
                                        </span>Please do not add Time Period and Brand as Entry Point or
                                        Dimensions</div> 
                                </div> -->
                                <!-- Brand Selection -->
                                <div class="SnapshotFields audience-comparison-dropdown brand-selection-dropdown" id="SnapshotFieldsBrandSelection">
                                    <div class="SnapshotFieldheading" style="display: flex; align-items: center; gap: 10px; cursor: pointer;"
                                         (click)="toggleBrandDropdown()">
                                        <input type="checkbox" id="brandSelection" class="alignCheckClick" 
                                            [checked]="!!selectedBrand"
                                            (change)="onBrandChange($event)"
                                            (click)="$event.stopPropagation()">
                                        <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; min-width: 0;">BRAND SELECTION</span>
                                        <div class="expand-icon-audience"
                                            [class.selected]="showBrandDropdown">
                                        </div>
                                    </div>
                                    <div class="lineSeparation"></div>
                                    
                                    <!-- Dropdown Content -->
                                    <div class="brand-selection-content" *ngIf="showBrandDropdown">
                                        <!-- Search Box -->
                                        <div class="search-reset-container" style="padding: 8px; border-bottom: 1px solid #e0e0e0; display: flex; gap: 8px; align-items: center;">
                                            <!-- Search Box -->
                                            <div style="position: relative; display: flex; align-items: center; flex: 1;">
                                                <div class="search-icon-small" style="position: absolute; left: 8px;"></div>
                                                <input type="text" 
                                                       placeholder="Search" 
                                                       [(ngModel)]="brandSearch"
                                                       (input)="onBrandSearchChange()"
                                                       [ngModelOptions]="{standalone: true}"
                                                       style="width: 100%; padding: 6px 30px 6px 36px; border: none; font-size: 0.75rem; outline: none;">
                                            </div>
                                        </div>
                                        
                                        <!-- Options List -->
                                        <div class="brand-selection-list" style="max-height: 200px; overflow-y: auto;">
                                            <!-- Individual Items with Radio Buttons -->
                                            <div *ngFor="let item of filteredBrandList" 
                                                 class="brand-selection-item"
                                                 [class.selected]="isBrandSelected(item)">
                                                <input type="radio" 
                                                       [id]="'brand_' + item.response_label"
                                                       name="brandSelectionRadio"
                                                       [checked]="isBrandSelected(item)"
                                                       (change)="onBrandSelect(item, $event)"
                                                       class="alignCheckClick"
                                                       style="margin-right: 8px; margin-top: 0.1rem;">
                                              
                                                <label *ngIf="item.response_label" 
                                                       [for]="'brand_' + item.response_label"
                                                       class="audience_config_name"
                                                       [attr.title]="item.response_label">
                                                    {{ item.response_label.split('|')[1] || item.response_label }}
                                                </label>
                                                
                                            </div>
                                            
                                            <!-- No Results -->
                                            <div *ngIf="filteredBrandList.length === 0" 
                                                 style="padding: 16px; text-align: center; color: #9CA3AF; font-size: 0.75rem;">
                                                No matching brands found
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="lineSeparation"></div>
                            </div>
                            
                            </div>
                    </div>
                </div>
                <!-- <div class="selection-panel-area">
                <div class="selection-panel-header">
                    SELECTION PANEL HEADERS
                </div>
                <div class="entry-points-area">
                    <div class="SnapshotFields" id="SnapshotFields">
                        <div class="SnapshotFieldheading">ENTRY POINTS</div>
                        <div class="lineSeparation"></div>
                        <div class="entry-points-field-area">
                            <div *ngFor="let entryPoint of entryPoints" class="checkboxClass">
                                <input type="checkbox" id="{{entryPoint.variable_label}}" class="alignCheckClick"
                                    [checked]="entryPoint.is_selected">
                                <label for="{{entryPoint.variable_label}}">{{
                                    entryPoint.variable_code}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dimensions-area">
                    <div class="SnapshotFields" id="SnapshotFields">
                        <div class="SnapshotFieldheading">DIMENSIONS</div>
                        <div class="lineSeparation"></div>
                        <div class="dimensions-field-area">
                            <div *ngFor="let dimension of dimensions">
                                <input type="checkbox" id="{{dimension.variable_label}}" class="alignCheckClick"
                                    [checked]="dimension.is_selected">
                                <label
                                    for="{{dimension.variable_label}}">{{dimension.variable_code==""?"None":dimension.variable_code}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            </div>
        </div>
    </div>

    <div class="snapshotBottomFieldArea">
        <div class="SnapshotButtonFields" (click)="clearAll()">
            <div class="button-img clearAll"></div>
            <div class="SnapshotButton">Reset</div>
        </div>
        <div class="SnapshotButtonFields" (click)="delete()">
            <div class="button-img delete"></div>
            <div class="SnapshotButton">Delete</div>
        </div>
        <!-- <div class="SnapshotButtonFields">
            <div class="button-img save"></div>
            <div class="SnapshotButton" (click)="save()">Save</div>
        </div> -->
        <div class="SnapshotButtonFields" [class.disabled]="!isSubmit" (click)="submit()">
            <div class="button-img submit"></div>
            <div class="SnapshotButton">Submit</div>
        </div>
    </div>
</form>
<app-shared-popup-snapshot *ngIf="showPopUp" [popUpParameter]="'WidgetLayout'" [parentSelectedWidget]="selectedwidget"
    (selectedwidget)="receiveLayoutWidget($event)" [showInputPopUp]="false"
    (closePopUp)="onCloseIconClick($event)"></app-shared-popup-snapshot>
<app-shared-popup-snapshot *ngIf="showErrorPopUp" [popUpParameter]="errorheaderTitle" [errorheaderTitle]="popUpTitle"
    [popUpMessage]="popUpMessage" [showInputPopUp]="false" [showErrorPopUp] = "true"
    (closeErrorPopUp)="onCloseIconClick($event)"></app-shared-popup-snapshot>
<app-shared-popup-snapshot *ngIf="showSubmitPopUp" [popUpParameter]="errorheaderTitle" [errorheaderTitle]="popUpTitle"
    [popUpMessage]="popUpMessage" [showInputPopUp]="false" [showErrorPopUp] = "true"
    (closeErrorPopUp)="onCloseIconClick($event)"></app-shared-popup-snapshot>
<!-- delete confirmation popup -->
<div *ngIf="showDeletePopup">
    <div class="overlay"></div>
    <app-delete-popup (dataEvent)="receivedDeleteConfirmation($event)"></app-delete-popup>
</div>